import { LocalStorage } from './localStorage';

export interface PostgradConsumptionStoredInfo {
  firstContentConsumedDate: string;
}

export class PostgradConsumptionHelper {
  static localStorageKey = 'postgradConsumption';

  static getStoredInfo(): PostgradConsumptionStoredInfo | null {
    return LocalStorage.get<PostgradConsumptionStoredInfo>(this.localStorageKey);
  }

  static storeInfo(key: keyof PostgradConsumptionStoredInfo, value: any): void {
    const storedInfo = this.getStoredInfo();

    const updatedStoredInfo = { ...storedInfo, [key]: value };

    LocalStorage.set(this.localStorageKey, updatedStoredInfo);
  }
}
